/* eslint-disable no-param-reassign */
import { BaseComponent, BElement } from "utils/base-component"
import SwellTooltip from "./swell-tooltip"
import "./index.scss"

const TOOLTIP_ROW_RE = /^(swell|wave-energy[1-4]?|wave-graph)$/
const PANEL_SELECTOR = "tbody[data-tab-panel]"

type CellMeta = {
  key: string
  index: number
}

declare global {
  interface Window {
    initFCTableCell?: (day: any, td: HTMLTableCellElement, meta: CellMeta) => boolean | void
  }
}

window.initFCTableCell = (day, td, { key, index }) => {
  if (!day.swellTooltips) day.swellTooltips = []
  if (key === "wave-graph") {
    day.swellTooltips[index] = JSON.parse(td.dataset.swellTooltip)
  }

  if (TOOLTIP_ROW_RE.test(key)) {
    const tooltip = new SwellTooltip(td, () => day.swellTooltips[index])
    tooltip.init()
  }

  return false
}

export class SurfForecastTable extends BaseComponent {
  static cssClass = "surf-forecast-table"

  init() {
    const tabElements = this.elements("tab")
    if (!tabElements.length) return

    const panels = Array.from(this.root.querySelectorAll<HTMLTableSectionElement>(PANEL_SELECTOR))

    const selectTab = (tab: BElement) => {
      const tabId = tab.element.dataset.tab
      if (!tabId) return

      tabElements.forEach((t) => {
        const selected = t.element.dataset.tab === tabId
        t.toggleModifier("active", selected)
        t.element.setAttribute("aria-selected", String(selected))
        t.element.tabIndex = selected ? 0 : -1
      })

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== tabId
      })
    }

    const focusTab = (index: number) => {
      tabElements[index]?.element.focus()
    }

    tabElements.forEach((tab, index) => {
      tab.element.addEventListener("click", (e) => {
        e.preventDefault()
        selectTab(tab)
      })

      tab.element.addEventListener("keydown", (e) => {
        switch (e.key) {
          case "ArrowLeft":
            e.preventDefault()
            focusTab((index - 1 + tabElements.length) % tabElements.length)
            break
          case "ArrowRight":
            e.preventDefault()
            focusTab((index + 1) % tabElements.length)
            break
          case "Home":
            e.preventDefault()
            focusTab(0)
            break
          case "End":
            e.preventDefault()
            focusTab(tabElements.length - 1)
            break
          case "Enter":
          case " ":
            e.preventDefault()
            selectTab(tab)
            break
          default:
            break
        }
      })
    })

    const activeTab =
      tabElements.find((tab) => tab.element.getAttribute("aria-selected") === "true") ||
      tabElements[0]
    if (activeTab) selectTab(activeTab)
  }
}
